import { render, staticRenderFns } from "./GiftChangeVariants.vue?vue&type=template&id=0304436e&lang=pug"
import script from "./GiftChangeVariants.vue?vue&type=script&lang=js"
export * from "./GiftChangeVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports